<template>
  <div>
    <datatable
      title="Admin Questions"
      :is_createable="false"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-questions',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'designator',
          value: 'designator'
        },
        {
          name: 'applicant_success_condition',
          value: 'applicant_success_condition'
        },
        {
          name: 'importance',
          value: 'importance'
        }
      ],
      data: [],
      operations: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAllQuestions().then(response => {
        this.data = response
      })
    },
    editClick (data) {
      this.create({ designator: 'admin-question-form-modal', component_name: 'AdminQuestionsForm', data, modal_title: data.designator })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
